<template>
  <div class="customerList">
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <UPDATE ref="childUpdate" @submit="submit" :updateData="updateData"></UPDATE>
    <table-page ref="childTable" @btnclick="bthClick" :pageData="pageData"></table-page>
  </div>
</template>

<script>
import Url from '@/views/proxy_cfint/util/url'
import DateUtil from '@/utils/IM/tradeDataUtil'
import FORM from '@/components/page/form'
import tablePage from '@/components/page/table'
import download from '@/utils/download'
import UPDATE from '@/components/page/update'
import Qs from 'qs'

let statusArr = { 0: '待發放', 1: '已發放', 2: '發放失敗' }
let statusArr2 = { 1: '同意', 2: '拒絕' }

export default {
  name: 'rebateMonth',
  components: {
    FORM,
    tablePage,
    UPDATE
  },

  data() {
    return {
      queryData: {},

      updateData: {
        cols: [
          {
            title: '發放狀態',
            field: 'status',
            type: 2,
            optionList: statusArr2,
            data: []
          },
          { title: '实际返佣金额', field: 'finalRebate', required: true, isNumber: true },
          { title: '备注信息', field: 'remark' },
          { title: 'id', field: 'id', hidden: true }
        ]
      },

      /*from查询表单*/
      formData: {
        hasLable: true,
        cols: [
          { title: 'groupId', field: 'groupId',data: DateUtil.getParamKey(this.$route.params),hidden:true },
          { title: '代理編碼(支持多個，多個時以,分隔)', field: 'agentCode' },
          { title: '所屬代理', field: 'directAgentCode' },
          {
            title: '發放狀態',
            field: 'status',
            type: 2,
            optionList: statusArr,
            data: []
          },
          { title: '时间', field: 'startTime' ,type: 5,format:'yyyy-MM-dd HH:mm:ss'},
          { click: window.$t('common.search') }
        ]
      },
      /*table生成*/
      pageData: {
        queryUrl: Url.adAgent.rebateMonthList+"?groupId="+DateUtil.getParamKey(this.$route.params),
        selection: false,
        sequence: false,
        method: 'get',
        cols: [
          { title: '结算代理', field: 'agentCode' },
          { title: '级别', field: 'level' },
          { title: '所属代理', field: 'directAgentCode' },
          { title: '所属一级代理', field: 'parentCode' },
          { title: '返佣', field: 'rebate' },
          { title: '最終返佣', field: 'finalRebate' },
          { title: '发放状态', field: 'status' ,render:(data,full)=>{
            return statusArr[data];
            }},
          {
            title: '返利時間', field: 'ctime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          {
            title: '生成時間', field: 'excTime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          {
            title: '審批時間', field: 'utime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          { title: '審批人', field: 'uname' },
          { title: '備註', field: 'remark' },
          {
            title: window.$t('common.operation'),
            btnClick: [
              {
                name: '審批',
                click: 'provide',
                type: 'primary',
                icon: 'el-icon-approve',
                auth: 'proxy_cfint:rebateMonth:provide', hidden: (data, full) => {
                  return full.status != 0
                }
              }
            ]
          }
        ]
      },
      totalNum: {}
    }
  },
  methods: {
    dataChange(url, option, suc, fail) {
      this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        if (suc && (typeof suc == 'function')) suc(res)
      }).catch(res => {
        if (fail && (typeof fail == 'function')) fail(res)
      })
    },

    submit(model) {
      this.dataChange(Url.adAgent.rebateMonthProvide, model, res => {
        if (res.code == 0) {
          this.$refs.childUpdate.close()
          this.$message.success('操作成功')
          this.$refs.childTable.defaultQueryData(this.queryData)
        } else {
          this.$message.error(res.message)
        }
      })
    },
    bthClick(clickName, row) {
      this.$refs.childUpdate.open(row)
    },

    /*查询表单按钮点击事件*/
    formclick(clickName, data) {
      if (window.$t('common.search') == clickName || '查询' == clickName) {
        data.startTime = data.startTime ? new Date(data.startTime).getTime() : ''
        this.queryData = data
        this.$refs.childTable.defaultQueryData(data)
      }
    }
  }

}
</script>
